<template>
  <v-container fluid fill-height>
    <v-slide-y-transition mode="out-in">
      <v-layout row wrap>
        <v-flex d-flex xs12>
          <v-layout row wrap align-center style="margin-top:0px;">
            <v-card style="margin-left:20px">
              <v-btn class="primary" v-on:click="sho1()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Regions</v-btn>
              <v-btn class="primary" v-on:click="sho2()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Cities</v-btn>
              <v-btn class="primary" v-on:click="sho3()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Service Location</v-btn>
              <v-btn class="primary" v-on:click="sho4()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Third Party</v-btn>
              <v-btn class="primary" v-on:click="sho5()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Accounted Customers</v-btn>
              <v-btn class="primary" v-on:click="sho6()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Employees</v-btn>
              <v-btn v-on:click="sho7() && activate(1)" :class="{ active_el: active_el == 1 }" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px;color: #ffffff">New Truck</v-btn>
              <v-btn class="primary" v-on:click="sho8()" flat style="margin-left: 10px;margin-top:20px;margin-bottom:20px">Pickup</v-btn>
            </v-card>
          </v-layout>
        </v-flex>
        <v-flex d-flex xs12>
          <v-flex xs3></v-flex>
          <v-flex xs6>
            <v-card style="margin-top: 20px">
              <v-card-text>
                <v-layout row wrap>
                <h3 style="text-align:left;margin-bottom: 10px">Add New Truck Details</h3>
                <!--<v-btn flat class="primary" style="margin-left:350px;margin-bottom: 10px;margin-top:-10px" v-on:click="back()">Back</v-btn>-->
                </v-layout>
                <v-divider divider: true style="margin-bottom: 50px"></v-divider>
                <v-flex style="margin-left:20px">
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:40px">
                      <label>Vehicle Provider</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-overflow-btn
                        :items="dropdown_list"
                        label="Select"
                        target="#dropdown-example"
                        style="margin-top:10px;"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:40px">
                      <label>Work Service location</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:20px">
                      <v-overflow-btn
                        :items="servicelocation_list"
                        label="Select"
                        target="#dropdown-example"
                        style="margin-top:10px;"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Vehicle Number</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-text-field
                        v-model="vehiclenumber"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Transportation Type</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-overflow-btn
                        :items="transportationtype_list"
                        label="Select"
                        target="#dropdown-example"
                        style="margin-top:10px;"
                        outline
                      ></v-overflow-btn>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Vehicle Details</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-textarea
                        v-model="vehicledetails"
                        outline
                        name="input"
                        value=""
                      ></v-textarea>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Permit of states</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-text-field
                        v-model="permit"
                        label=""
                        outline
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs4 style="margin-top:20px">
                      <label>Permit Expiry Date</label>
                    </v-flex>
                    <v-flex xs6 style="margin-top:0px">
                      <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        :return-value.sync="date"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        style="margin-left:20px"
                      >
                      <v-text-field
                        slot="activator"
                        v-model="date"
                        label="Select Date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                      <v-date-picker v-model="date" no-title scrollable>
                        <v-spacer></v-spacer>
                        <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                        <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                      </v-date-picker>
                    </v-menu>
                  </v-flex>
                  </v-layout>
                </v-flex>
                <v-btn class="primary" style="margin-left:20px;" v-on:click="submit()">Submit</v-btn>
                <v-btn class="default" style="margin-left:20px;">Reset</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs3></v-flex>
        </v-flex>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      active_el: 1,
      firstname: '',
      lastname: '',
      email: '',
      dropdown_list: ['Mumbai', 'Kolkata', 'Pune', 'Nagpur'],
      servicelocation_list: ['Mumbai', 'Kolkata', 'Pune', 'Nagpur'],
      vehiclenumber: '',
      transportationtype_list: '',
      vehicledetails: '',
      permit: '',
      menu: false,
      date: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {
    submit () {
      this.$router.push('/Truckingalltrucksreport')
    },
    sho1 () {
      this.$router.push('/Truckingaddregions')
    },
    sho2 () {
      this.$router.push('/Truckingaddcities')
    },
    sho3 () {
      this.$router.push('/Truckingservicelocation')
    },
    sho4 () {
      this.$router.push('/Truckingthirdpartytransporters')
    },
    sho5 () {
      this.$router.push('/Truckingaccountedcustomers')
    },
    sho6 () {
      this.$router.push('/Truckingemployees')
    },
    sho7 () {
      this.$router.push('/Truckingaddnewtruck')
    },
    sho8 () {
      this.$router.push('/Truckingpickuprequest')
    },
    activate: function (el) {
      this.active_el = el
    }
  }
}
</script>
<style>
 .active_el{
    background-color: #00C853
  }
</style>



// WEBPACK FOOTER //
// src/components/Truckingaddnewtruck.vue